export const getLocalStorageItem = (id: string): string | false | null => {
  return hasLocalStorage() && window.localStorage.getItem(id)
}

export const setLocalStorageItem = (id: string, value: string): void => {
  hasLocalStorage() && window.localStorage.setItem(id, value)
}

export const hasLocalStorage = (): boolean => {
  const mod = 'https://bit.ly/3aipbGd'
  try {
    localStorage.setItem(mod, mod)
    localStorage.removeItem(mod)
    return true
  } catch (e) {
    return false
  }
}
